module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 027.9b3f0c33.jpg";